
import { Component, Vue, Prop } from 'vue-property-decorator';
import MissionTabNames from '@/flightpath-components/services/missionTabNames';

@Component
export default class MissionTabs extends Vue {
  @Prop() selectedTab!: MissionTabNames;

  tabNames = MissionTabNames;
  tab = 0;

  mounted() {
    this.tab = Object.values(MissionTabNames).indexOf(this.selectedTab);
  }
}
